var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$scopedSlots.default || Object.entries(_vm.$attrs).length)?_c('div',{staticClass:"c-long-read-target"},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }